import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export default function Contact() {
  return (
    <div className="pt-20">
      {/* Hero Banner */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              联系我们
            </h1>
            <p className="text-xl text-blue-100">
              我们期待与您的合作，欢迎随时联系
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card>
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4">
                  <Phone className="h-6 w-6" />
                </div>
                <h3 className="font-bold text-lg mb-2">售前咨询</h3>
                <p className="text-gray-600">0510-8822 6558</p>
                <p className="text-gray-600">021-6052 6680</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4">
                  <Mail className="h-6 w-6" />
                </div>
                <h3 className="font-bold text-lg mb-2">邮件咨询</h3>
                <p className="text-gray-600">sales@hypwr.com</p>
                <p className="text-gray-600">support@hypwr.com</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4">
                  <Clock className="h-6 w-6" />
                </div>
                <h3 className="font-bold text-lg mb-2">工作时间</h3>
                <p className="text-gray-600">周一至周五</p>
                <p className="text-gray-600">9:00-18:00</p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4">
                  <MapPin className="h-6 w-6" />
                </div>
                <h3 className="font-bold text-lg mb-2">公司地址</h3>
                <p className="text-gray-600">无锡市锡山区二泉东路19号</p>
                <p className="text-gray-600">集智商务广场16楼</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Map & Address */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Map Placeholder */}
            <div className="aspect-video bg-gray-200 rounded-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=800&q=80"
                alt="Location Map"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Contact Details */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">联系方式</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 flex-shrink-0">
                    <Phone className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">电话咨询</h3>
                    <p className="text-gray-600">售前咨询：0510-8822 6558 / 021-6052 6680</p>
                    <p className="text-sm text-gray-500">周一至周五 9:00-18:00</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 flex-shrink-0">
                    <Mail className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">邮件咨询</h3>
                    <p className="text-gray-600">sales@hypwr.com</p>
                    <p className="text-gray-600">support@hypwr.com</p>
                    <p className="text-sm text-gray-500">1-2两个工作日回复</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 flex-shrink-0">
                    <MapPin className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900">公司地址</h3>
                    <p className="text-gray-600">无锡市锡山区二泉东路19号集智商务广场16楼</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
